import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {Audits, Content, Page} from "./audit.models";
import {any} from "codelyzer/util/function";

@Injectable({
  providedIn: 'root'
})
export class AuditServiceService {
  config = environment;
  queryParams: HttpParams;
  constructor(private _http: HttpClient) {
  }

 /* getAuditSMS(data : any): Observable<Audits> {
    console.log('data ', data)
    let queryParams = new HttpParams();
    queryParams.append("page",data.page);
    queryParams.append("size",data.size);
    queryParams.append("search",data.search);
    return this._http.get<Audits>(this.config.BASE_URL_SMS + `/v1/audit/sms`,{params: queryParams});
  }*/

  getAuditSms(search, page: number, size: number) : Observable<Page<Content>> {
    console.log(search, page, size)
     this.queryParams = new HttpParams();
    this.queryParams.append("page",''+ page);
    this.queryParams.append("size",''+size);
    if(search){
      this.queryParams.append("search",search);
    }
    console.log( this.queryParams.get('page'))
    return this._http.get<Page<Content>>(this.config.BASE_URL_SMS + `/v1/audit/sms?search=${search}&page=${page}&size=${size}`,{params:  this.queryParams});
  }


  sentSms(transId) {
    return this._http.post<any>(this.config.BASE_URL_SMS + `/v1/audit/sms/resent/${transId}`,{});
  }
}
